import { DepositStatementEnum } from "@/pages/DigitalAccount/Saman/types";
import { DepositDebitTypeEnum, DepositStatementActionEnum } from "@payping/api";

export const actionFilter = (actionType?: DepositStatementEnum): DepositStatementActionEnum | undefined => {
  switch (actionType) {
    case DepositStatementEnum.ALL:
      return undefined;
    case DepositStatementEnum.DEBIT:
      return DepositStatementActionEnum.DEBIT;
    case DepositStatementEnum.CREDIT:
      return DepositStatementActionEnum.CREDIT;
    case DepositStatementEnum.PayPingWage:
      return undefined;
    default:
      return undefined;
  }
};

export const wageFilter = (wageType?: DepositStatementEnum): DepositDebitTypeEnum | undefined => {
  switch (wageType) {
    case DepositStatementEnum.ALL:
      return undefined;
    case DepositStatementEnum.DEBIT:
      return undefined;
    case DepositStatementEnum.CREDIT:
      return undefined;
    case DepositStatementEnum.PayPingWage:
      return DepositDebitTypeEnum.PayPingWage;
    default:
      return undefined;
  }
};
